"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebRoutes = void 0;
const base_1 = require("../base");
const constants_1 = require("../constants");
/**
 * API routes for web application configuration
 * Handles web app specific settings and configuration
 */
class WebRoutes extends base_1.ApiBase {
    /**
     * Get web configuration from the API
     * @returns Promise resolving to web app configuration
     * @throws Error if the API request fails
     */
    async getWebConfig() {
        return this.apiGet(`${constants_1.ROUTES.WEB}/config`);
    }
}
exports.WebRoutes = WebRoutes;
//# sourceMappingURL=web.js.map